import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../injectable/auth/auth.service';
import { UserService } from '../injectable/user.service';
import { VERSION } from 'src/environments/version';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { AppState, ResetUser, SetCategories, SetUser } from '../app-state';
import { AdminService } from '../injectable/admin.service';
import { GenericErrorModalService } from '../injectable/generic-error-handling/generic-error-modal.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  @Select(AppState.user) user$: Observable<string>;
  @Select(AppState.username) username$: Observable<string>;
  @Select(AppState.isUserAdmin) isUserAdmin$: Observable<boolean>;

  lang: string;
  user: string;
  userState: boolean;
  version = VERSION.version;

  langs = [
    {
      value: 'it',
      image: 'assets/icons/it.png',
      language: 'Italiano'
    },
    {
      value: 'en',
      image: 'assets/icons/en.png',
      language: 'English'
    },
    {
      value: 'fr',
      image: 'assets/icons/fr.png',
      language: 'Français'
    },
    {
      value: 'de',
      image: 'assets/icons/de.png',
      language: 'Deutsch'
    },
    {
      value: 'pt',
      image: 'assets/icons/pt.png',
      language: 'Português'
    },
    {
      value: 'es',
      image: 'assets/icons/es.png',
      language: 'Español'
    }
  ];

  constructor(
    public authService: AuthService,
    public userService: UserService,
    private adminService: AdminService,
    private translate: TranslateService,
    private router: Router,
    private route: ActivatedRoute,
    private store: Store,
    private genericErrorModalService: GenericErrorModalService
  ) { }

  ngOnInit(): void {
    this.user = sessionStorage.getItem('user');
    this.lang = sessionStorage.getItem('lang');
    if (this.user) {
      this.getUserInfo();
    } else {
      this.router.navigate(['/login'], { relativeTo: this.route });
    }
    if (!this.lang) {
      this.lang = navigator.language.toString().substring(0, 2);
    }
    this.translate.setDefaultLang(this.lang);
  }


  selectedLangChange(userlanguage: string) {
    this.translate.setDefaultLang(userlanguage);
    sessionStorage.setItem('lang', userlanguage);
    this.lang = sessionStorage.getItem('lang');
    this.userService.changeLanguage(this.lang.toUpperCase()).subscribe((resp) => {
    });
  }

  logout() {
    this.authService.token = null;
    sessionStorage.clear()
    this.router.navigate(['/login'], { relativeTo: this.route });
    this.store.dispatch(new ResetUser());
    window.location.reload()
  }

  changePassword() {
    this.userService.loginRoute = true;
    this.router.navigate(['change-password']);
  }

  getUserInfo() {
    this.userService.user().subscribe(user => {
      if (user) {
        this.store.dispatch(new SetUser(user));
      } else {
        this.router.navigate(['/login'], { relativeTo: this.route });
      }
    }, error => {
      // console.error(error);
      this.genericErrorModalService.open('Errore nel caricamento delle info dello User', error);
        sessionStorage.clear();
        localStorage.clear();
        this.router.navigate(['/login']);
    });
  }

}
